module.exports = __webpack_public_path__ + "static/media/become_a_member_mobile.1b3b818c.jpg";